import type { BigStepInstance } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { WorkflowCaseStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'

/**
 * 現在アクティブな大ステップ名 (= 8080 `demand/cases.html` の「次に着手する大ステップ」)。
 *
 * 8080 は進捗セルを 2 段で組み、 上段に**今どこにいるか**を出している
 * (`th.col-progress` の title も「現在着手中のステップ (タスクボールの位置)」)。
 * 「2/13」 だけだと、 その 2 が何のステップなのかが読み手に伝わらないため。
 *
 * 定義は spec `workflow/workflow.md` AC-WFW-001 の「現在アクティブなサブステップ
 * (= 先頭の未完了サブステップ)」 に合わせ、 **そのサブステップが属する大ステップ**の title を返す。
 * あなたの対応列 (同 AC の (a)〜(d)) と同じ「先頭の未完了」 を軸にすることで、
 * 進捗セルと あなたの対応列 が別のステップを指す食い違いが起きない。
 *
 * 全サブステップ完了済み / ステップが 1 つも無い場合は undefined (呼び出し側で非表示)。
 *
 * 終端 (完了 / 削除済み) のケースにも「現在アクティブな大ステップ」は無いので
 * undefined を返す。 終端ケースはサブステップが未完了のまま終わることがあり
 * (完了操作・削除は残サブステップを完了させない)、 status を見ないと
 * 「終わったケースなのに『いま○○ステップ』」 と読める上段が出てしまう。
 * 判定する status は `isWorkflowCaseReadonly` (COMPLETE / DELETED) と同じ集合。
 */
export function activeBigStepName(
  bigSteps: readonly BigStepInstance[],
  status: WorkflowCaseStatus,
): string | undefined {
  if (
    status === WorkflowCaseStatus.COMPLETE ||
    status === WorkflowCaseStatus.DELETED
  ) {
    return undefined
  }
  for (const bs of bigSteps) {
    if (bs.subSteps.some((ss) => !ss.isCompleted)) {
      return bs.title === '' ? undefined : bs.title
    }
  }
  return undefined
}
